module.exports = __webpack_public_path__ + "filetype-pdf.svg?745797b68538109295a1c60461e3697b";